import { Button, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import DealershipBottomSheet from './DealershipBottomSheet';
const useStyles = makeStyles({
  root: {
    width: '100%',
    maxWidth: '100%',
    flexShrink: 0,
    boxSizing: 'border-box',
    background: '#FFFFFF',
    zIndex: 5,
  },
  bottomSheetBtnContainer: {
    borderBottom: '1px solid #E4E7EC',
    width: '100%',
    maxWidth: '100%',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
  },
  bottomSheetBtn: {
    fontFamily: 'Lato',
    fontSize: '12px',
    fontWeight: '600',
    lineHeight: '16.08px',
    color: 'rgba(98, 47, 238, 1)',
  },
});

const BottomSheetContainer = ({ data, isSheetOpen, toggleSheet, handleRemove, selectAllMode, totalCount, excludedCount, displaySelectedCount }) => {
  const classes = useStyles();
  const buttonLabel = selectAllMode
    ? `${totalCount - (excludedCount ?? 0)} dealerships selected`
    : `${displaySelectedCount ?? 0} dealerships selected`;

  return (
    <Grid container direction="column" justifyContent="flex-end" className={classes.root}>
      <Grid item>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.bottomSheetBtnContainer}
        >
          <Grid item>
            <DealershipBottomSheet
              isOpen={isSheetOpen}
              onClose={toggleSheet}
              data={data?.dealerships}
              handleRemove={handleRemove}
              selectAllMode={selectAllMode}
              totalCount={totalCount}
              displaySelectedCount={displaySelectedCount}
            />
          </Grid>
          <Grid item>
            <Button variant="text" onClick={toggleSheet} className={classes.bottomSheetBtn}>
              {buttonLabel}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BottomSheetContainer;
